export default {
  landingPage: '/prefill',
  editPage: '/edit',
  summaryPage: '/summary',
  errorPage: '/error',
  apiErrorPage: '/apierror',
  confirmationPage: '/confirmation',
  licenses: '/licenses',
}
